import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-ddance',
  templateUrl: './program-ddance.component.html',
  styleUrls: ['./program-ddance.component.scss']
})
export class ProgramDdanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
